<template>
  <div class="page" :style="{ height: fixedHeight + 'px' }">
    <div class="searchBox">
      <el-form>
        <el-row style="display: flex;align-items: center;">
          <el-col :span="8">
            <el-form-item>
              <el-input
                style="width: 200px; margin-right: 10px"
                placeholder="请输入关键字"
                v-model="params.keywords"
                @keyup.enter.native="changeSearch"
                clearable
                size="small"
              ></el-input>
              <el-button
                @click="changeSearch"
                icon="el-icon-search"
                type="warning"
                size="small"
                >搜索</el-button
              >
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出库时间" :label-width="'80px'">
              <el-date-picker
                style="width: 250px"
                v-model="dateTime"
                type="daterange"
                range-separator="-"
                value-format="timestamp"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="changeDate"
                size="small"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <resetBtn @reset="reset"></resetBtn>
          </el-col>
          <el-col :span="2" style="text-align: right">
            <el-button
            v-if="$buttonAuthority('cangku2-chuku-add')"
              @click="handleClick"
              type="warning"
              size="small"
              >新建</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="tabLine">
      <div
        class="tabItem"
        :class="[curTabIndex == 0 ? 'active' : '']"
        @click="changeTab(0)"
      >
        全部
      </div>
      <div
        class="tabItem"
        :class="[curTabIndex == 1 ? 'active' : '']"
        @click="changeTab(1)"
      >
        调拨出库
      </div>
      <!-- <div class="tabItem" :class="[curTabIndex==2?'active':'']" @click="changeTab(2)">损耗出库</div> -->
      <div
        class="tabItem"
        :class="[curTabIndex == 3 ? 'active' : '']"
        @click="changeTab(3)"
      >
        销售出库
      </div>
      <div
        class="tabItem"
        :class="[curTabIndex == 4 ? 'active' : '']"
        @click="changeTab(4)"
      >
        自用出库
      </div>
      <div
        class="tabItem"
        :class="[curTabIndex == 5 ? 'active' : '']"
        @click="changeTab(5)"
      >
        报废出库
      </div>
    </div>
    <div class="pageConBox">
      <el-table
        default-expand-all
        :data="tableData"
        style="width: 100%"
        ref="table"
      >
        <el-table-column label="编号" prop="no"> </el-table-column>
        <el-table-column label="出库日期">
          <template slot-scope="scope">
            <span>{{ scope.row.outTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="出库人" prop="outUserName"> 
          <template slot-scope="scope">
            <span>{{ scope.row.outUser.title }}</span>
          </template>
        </el-table-column>
        <el-table-column label="去往门店" prop="otherShopName">
        </el-table-column>
        <el-table-column label="出库类型">
          <template slot-scope="scope">
            <span> {{ scope.row.outOrderType?scope.row.outOrderType.title:'--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="see(scope.row.id)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <page
        :page="page.page"
        :total="page.total"
        :pageSize="page.pageSize"
        @change="pageChange"
        style="padding: 20px 0"
      ></page>
    </div>
    <div v-if="drawerSee_state">
      <drawerSee :id="curId" @submit="submit_drawerSee"></drawerSee>
    </div>
  </div>
</template>
<script>
import page from "@/components/page.vue";
import resetBtn from "../../components/resetBtn.vue";
import drawerSee from "./drawerSee.vue";
import { getTrackSimple, codeinfoSplit } from "../../api/stockApi.js";
export default {
  components: {
    page,
    resetBtn,
    drawerSee,
  },
  data() {
    return {
      fixedHeight: "",
      tableData: [],
      dateTime: [],
      params: {
        outDateStart: "", // 入库查询开始日期
        outDateEnd: "", // 入库查询结束日期
        outOrderType: "", // 出库类型  0：调拨出库  1：部门领用  2：采购退货   3：损耗盘点出库   4：销售出库   5：其他出库   6：报废出库  7：门店申请出库   8：条码拆分出库  9：Pda出库  10：自用出库
        shopId: this.$store.getters.curShopInfo.shop_id,
        keywords: "",
      },
      // 当前tab
      curTabIndex: 0,
      page: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      goodscustom: "",
      trackData: "",
      splitCustomCodeParams: {
        splitTimes: 1,
        goodsCustomCode: "",
        useShopId: "",
      },
      // 查看
      drawerSee_state: false,
      curId: "",
    };
  },
  created() {
    this.fixedHeight = document.documentElement.clientHeight - 76;
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    handleClick(){
      this.$router.push({
					path: 'chukuAdd'
				})
    },
    // 查看
    see(id) {
      this.drawerSee_state = true;
      this.curId = id;
    },
    submit_drawerSee() {
      this.drawerSee_state = false;
    },
    changeTab(i) {
      this.curTabIndex = i;
      if (i === 1) {  //调拨出库
        this.params.outOrderType = "2";
      }  else if (i === 3) {  //销售出库
        this.params.outOrderType = "1";
      } else if (i === 4) {  //自用出库
        this.params.outOrderType = "3";
      } else if (i === 5) {  //报废出库
        this.params.outOrderType = "4";
      } else if (i === 0) { //全部
        this.params.outOrderType = "";
      }
      this.page.page = 1;
      this.getTableData();
    },
    reset() {
      this.params.outDateStart = "";
      this.params.outDateEnd = "";
      this.params.keywords = "";
      this.dateTime = [];
      this.page.page = 1;
      this.getTableData();
    },
    changeDate() {
      this.page.page = 1;
      this.params.outDateStart = this.dateTime ? this.dateTime[0] : "";
      this.params.outDateEnd = this.dateTime ? this.dateTime[1] : "";
      this.getTableData();
    },
    changeSearch() {
      this.page.page = 1;
      this.getTableData();
    },
    // 改变分页
    pageChange(num) {
      this.page.page = num;
      this.getTableData();
    },
    getTableData() {
      let params = {
        keywords: this.params.keywords,
        shopId: this.params.shopId,
        outDateStart: this.params.outDateStart,
        outDateEnd: this.params.outDateEnd,
        outOrderType: this.params.outOrderType,
        pageIndex: this.page.page,
        pageSize: this.page.pageSize,
      };
      let loading = this.$loading();
      this.$http
        .post(process.env.VUE_APP_Url66 + "api/Out/list", params)
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.tableData = res.data.list;
            this.page.total = res.data.count;
          }
        });
    },
    toogleExpand(row) {
      let $table = this.$refs.table;
      this.tableData.map((item) => {
        if (row.skus != item.skus) {
          $table.toggleRowExpansion(item, false);
        }
      });
      $table.toggleRowExpansion(row);
    },
    searchcustom(val) {
      console.log(val, "-----");
      getTrackSimple({ barcode: val }).then((res) => {
        if (res.code == 0) {
          console.log(res, "res");
          this.trackData = res.data;
          this.goodscustom = "";
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.page {
  display: flex;
  flex-direction: column;
  .searchBox {
    .el-form-item {
      margin-bottom: 0;
    }
  }
  .tabLine {
    margin-top: 12px;
    display: flex;
    .tabItem {
      padding: 0 16px;
      line-height: 36px;
      text-align: center;
      border-right: 1px solid #f2f2f2;
      cursor: pointer;
      font-size: 14px;
      background-color: #fff;
      &.active {
        color: $mainColor;
      }
    }
  }
  .pageConBox {
    flex: 1;
    border-right: 1px solid #f2f2f2;
    min-height: 0;
  }
}
</style>
